import React from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";

function ListSkills({ skill, level }) {
  return (
    <div>
      <li className="gap-2 flex items-center font-semibold text-gray-800">
        <span>
          <BsFillPatchCheckFill fontSize={"1.2rem"} />
        </span>
        <p className="relative top-[13px] lg:text-xl">
          {skill} <br />
          <span className="text-[0.7rem] lg:text-[1rem] lg:font-normal ">{level}</span>
        </p>
      </li>
    </div>
  );
}

export default ListSkills;
